import { Locale } from 'date-fns';
import { enUS, zhCN } from 'date-fns/locale';
import { LocaleId, useIntl } from 'intl-lib';

const locales: Partial<Record<LocaleId, Locale>> = {
  'en-US': enUS,
  'zh-CN': zhCN,
};

export default function useParamsLocale() {
  const locale = useIntl(state => state.locale);
  return locales[locale] ?? locales['en-US'];
}
